module.exports = __webpack_public_path__ + "img/待定标@3x.5e4971b6.png";